<template>
  <div class="plan-card-skeleton">
    <!-- Header skeleton -->
    <div class="plan-header-skeleton">
      <v-skeleton-loader type="text" class="title-skeleton" />
      <v-skeleton-loader type="text" class="subtitle-skeleton" />
      <div class="price-skeleton">
        <v-skeleton-loader type="text" class="price-amount-skeleton" />
        <v-skeleton-loader type="text" class="price-currency-skeleton" />
      </div>
    </div>

    <!-- Features skeleton -->
    <div class="plan-features-skeleton">
      <v-skeleton-loader type="text" class="section-title-skeleton" />
      <div class="features-list-skeleton">
        <div v-for="i in 4" :key="i" class="feature-skeleton">
          <div class="feature-icon-skeleton"></div>
          <v-skeleton-loader type="text" class="feature-text-skeleton" />
        </div>
      </div>
    </div>

    <!-- Actions skeleton -->
    <div class="plan-actions-skeleton">
      <v-skeleton-loader type="button" class="btn-skeleton" />
      <div class="discount-section-skeleton">
        <v-skeleton-loader type="text" class="discount-label-skeleton" />
        <v-skeleton-loader type="button" class="discount-btn-skeleton" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.plan-card-skeleton {
  width: 340px;
  min-height: 520px;
  background: white;
  border: 1px solid var(--grey);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  padding: 28px;
  position: relative;
  display: flex;
  flex-direction: column;

  @media (max-width: 1200px) {
    width: 300px;
    padding: 24px;
    min-height: 480px;
  }

  @media (max-width: 1100px) {
    width: 280px;
    padding: 22px;
    min-height: 470px;
  }

  @media (max-width: 1000px) {
    width: 270px;
    padding: 20px;
    min-height: 460px;
  }

  @media (max-width: 900px) {
    width: 260px;
    padding: 20px;
    min-height: 450px;
  }

  @media (max-width: 820px) {
    width: 250px;
    padding: 18px;
    min-height: 440px;
  }

  @media (max-width: 950px) {
    width: 100%;
    max-width: 500px;
    min-height: auto;
    margin-bottom: 20px;
    padding: 32px;
  }

  @media (max-width: 768px) {
    padding: 24px;
  }
}

.plan-header-skeleton {
  text-align: center;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--light-grey);
}

.title-skeleton {
  margin-bottom: 8px;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
}

.subtitle-skeleton {
  width: 40%;
  margin: 0 auto 12px auto;
}

.price-skeleton {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.price-amount-skeleton {
  width: 60px;
}

.price-currency-skeleton {
  width: 30px;
}

.plan-features-skeleton {
  flex: 1;
  margin-bottom: 24px;
}

.section-title-skeleton {
  margin-bottom: 16px;
  width: 70%;
}

.features-list-skeleton {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature-skeleton {
  display: flex;
  align-items: center;
  gap: 12px;
}

.feature-icon-skeleton {
  width: 16px;
  height: 16px;
  background: var(--light-grey);
  border-radius: 50%;
  flex-shrink: 0;
}

.feature-text-skeleton {
  flex: 1;
}

.plan-actions-skeleton {
  margin-top: auto;
}

.btn-skeleton {
  width: 100%;
  margin-bottom: 16px;
  height: 48px;
}

.discount-section-skeleton {
  text-align: center;
}

.discount-label-skeleton {
  margin-bottom: 8px;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.discount-btn-skeleton {
  width: 60%;
  height: 40px;
}

// Override Vuetify skeleton styles for better appearance
:deep(.v-skeleton-loader__text) {
  height: 16px;
  margin: 4px 0;
}

:deep(.v-skeleton-loader__button) {
  height: 48px;
  border-radius: 8px;
}
</style>